import {CustomerStoryContentSliceV2PrimaryQuotesItem} from 'prismicio-types'
import {memo, useEffect, useRef, useState} from 'react'
import {createPortal} from 'react-dom'
import {Icon} from 'src/common/Icon'
import {Taprom} from 'next/font/google'

const taprom = Taprom({
  subsets: ['latin'],
  display: 'swap',
  weight: '400',
})

export const Quote = memo(({quote}: {quote: CustomerStoryContentSliceV2PrimaryQuotesItem}) => {
  const containerRef = useRef<HTMLElement | null>(null)
  const [shouldMount, setShouldMount] = useState(false)
  const autorNameArr = quote.author_name?.split(' ') ?? []

  const content = (
    <div className="mb-16 mt-12 flex flex-col gap-8 rounded-xl bg-beige-100 px-5 pb-6 pt-5 md:p-16">
      <div className="flex flex-col items-start gap-2 md:flex-row md:gap-6">
        <Icon name="quotation-mark" className="h-5 w-5 min-w-5 text-neon-550" />
        <p className="md:text-h4 text-[22px] font-medium leading-6 text-moss-black">{quote.quote}</p>
      </div>
      <div className="flex flex-col gap-3 text-grey-550 md:flex-row md:items-center md:gap-6 md:pl-11">
        {autorNameArr.length && (
          <span className="flex">
            {autorNameArr.map((word, index) => (
              <p className={`text-body-xl rotate-[-3deg] ${taprom.className}`} key={word + index}>
                {word}
              </p>
            ))}
          </span>
        )}
        <p className="text-body-m">{quote.author_role}</p>
      </div>
    </div>
  )

  // Get container
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const container = document.getElementById(quote.rte_label_content!)

      if (container) {
        containerRef.current = container
        setShouldMount(true)
        observer.disconnect()
      }
    })

    observer.observe(document.body, {childList: true, subtree: true})

    // Cleanup observer on unmount
    return () => observer.disconnect()
  })

  return shouldMount && containerRef.current ? createPortal(content, containerRef.current) : null
})
